var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60966 2.25154C3.98498 1.4095 2.03659 2.52115 2.03659 4.19448V17.8058C2.03659 19.4801 3.98498 20.5908 5.60966 19.7487L18.7341 12.9431C20.3732 12.0932 20.3732 9.90705 18.7341 9.05818L5.60966 2.25154ZM0.5 4.19448C0.5 1.35675 3.74424 -0.38398 6.34415 0.965039L19.4686 7.7707C22.1771 9.1754 22.1771 12.8249 19.4686 14.2296L6.34415 21.0352C3.74424 22.3833 0.5 20.6445 0.5 17.8058V4.19448Z",
    fill: "#034A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.adcaaae89cd205394af77ee978937946.svg";
export { ForwardRef as ReactComponent };